import React, { useEffect } from "react";
import "./ThankYouPage.css";

const ThankYouPage = () => {
  useEffect(() => {
    // Clear swipe-related localStorage items to reset state
    localStorage.removeItem("menToShow");
    localStorage.removeItem("currentIndex");
    localStorage.removeItem("swipeCount");
    // Keep womanId for potential reuse
  }, []);

  return (
    <div className="thank-you-page">
      <div className="thank-you-content">
        <div className="logo-and-heading">
          <img
            src="/logos/bond_logo_white.png"
            alt="Bond Logo"
            className="thank-you-logo"
          />
          <h2>Thank You</h2>
        </div>

        <p>
          You have completed your recommendations. We appreciate your
          engagement in the Bond experience.
        </p>

        <p className="refer-text">
          Increase your matching priority by{" "}
          <a
            href="https://www.thebondnyc.com/refer"
            target="_blank"
            rel="noopener noreferrer"
          >
            referring friends.
          </a>
        </p>
      </div>
    </div>
  );
};

export default ThankYouPage;